import type { Chart } from 'chart.js';
import { useEffect, useRef } from 'react';

type HtmlLegendProps = {
  chartInstance: Chart<'pie'> | null;
  className?: string;
};

export function HtmlLegend({ chartInstance, className = '' }: HtmlLegendProps) {
  const legendContainerRef = useRef<HTMLUListElement | null>(null);

  useEffect(() => {
    const chart = chartInstance;
    const container = legendContainerRef.current;

    if (!chart || !container) return;

    container.replaceChildren();

    const items = chartInstance?.options?.plugins?.legend?.labels?.generateLabels?.(chartInstance as Chart);

    items?.forEach((item) => {
      const li = document.createElement('li');
      li.style.alignItems = 'center';
      li.style.cursor = 'pointer';
      li.style.display = 'flex';
      li.style.flexDirection = 'row';

      // Color box
      const boxSpan = document.createElement('span');
      boxSpan.style.background = item.fillStyle as string;
      boxSpan.style.borderColor = item.strokeStyle as string;
      boxSpan.style.borderWidth = `${item.lineWidth}px`;
      boxSpan.style.borderRadius = '50%';
      boxSpan.style.display = 'inline-block';
      boxSpan.style.flexShrink = '0';
      boxSpan.style.height = '20px';
      boxSpan.style.marginRight = '10px';
      boxSpan.style.width = '20px';

      // Text
      const textContainer = document.createElement('p');
      textContainer.style.color = item.fontColor as string;
      textContainer.style.margin = '0';
      textContainer.style.padding = '0';
      textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
      textContainer.style.fontSize = '13px';

      const text = document.createTextNode(item.text);
      textContainer.appendChild(text);

      li.appendChild(boxSpan);
      li.appendChild(textContainer);
      container.appendChild(li);
    });
  }, [chartInstance]);

  return <ul className={`flex flex-col items-start gap-2 list-none p-0 m-0 shrink-0 ${className}`} ref={legendContainerRef} />;
}
